/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ActiveDealsState {
  deals: [] | null;
}

const initialState: ActiveDealsState = {
  deals: null,
};

export const activeDealsSlice = createSlice({
  name: 'activeDeals',
  initialState,
  reducers: {
    setActiveDeals: (state, { payload }) => {
      state.deals = payload;
    },
  },
  extraReducers: () => {},
});

export const { setActiveDeals } = activeDealsSlice.actions;
export const activeDealsSelector = (state: RootState) => state.activeDeals;
